<template>
    <div>
        
        <FirstTimeDentist />
    </div>
</template>

<script>

import FirstTimeDentist from '../blog-details/FirstTimeDentist.vue'

export default {
    components: {
       
        FirstTimeDentist,
    }
}
</script>